var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"rules":_vm.rules,"enum":_vm.hatirlat,"disabled":_vm.isDisabled,"labels":_vm.hatirlatLabel,"label":"Önceden Hatırlat"},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }